// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1137":"a41cac7c","1850":"a41cac7c"}[chunkId] + ".chunk.css";
};